import type { ContainerElementProps } from './types';

const usePresenter = (props: ContainerElementProps): ContainerElementProps => {
  return props;
};

export default usePresenter;
